module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 14 14",
      url: "img/" + "sprite.svg#cancel-usage",
      toString: function () {
        return this.url;
      }
    }